import {Component, OnInit} from "@angular/core";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {take} from "rxjs/operators";
import {VoucherRequest} from "../../../shared/models/voucherRequest";
import {VoucherRequestService} from "../../../shared/services/voucher-request/voucher-request.service";


@Component({
    selector: "app-voucher-requests-modal",
    templateUrl: "./voucher-requests-modal.component.html",
    styleUrls: ["./voucher-requests-modal.component.scss"]
})
export class VoucherRequestsModalComponent implements OnInit {

    requests: Array<VoucherRequest> = [];

    loading: boolean = true;

    error: string = null;

    constructor (
        public activeModal: NgbActiveModal,
        private voucherRequestService: VoucherRequestService
    ) {}

    ngOnInit () {
        this.voucherRequestService.list().pipe(take(1)).
            subscribe(
                (requests: Array<VoucherRequest>) => {
                    this.requests = requests;
                    this.loading = false;
                },
                (err) => {
                    this.error = "Une erreur est survenue lors de la récupération des demandes";
                    this.loading = false;
                    throw err;
                }
            );
    }

    /*
     * Un responsable peut gérer plusieurs centres : la colonne n'a d'intérêt
     * que si les demandes affichées portent effectivement sur plusieurs d'entre eux.
     */
    get showCenterColumn (): boolean {
        const centerIds = new Set(this.requests.map((request) => request.exam_center?.id));

        return centerIds.size > 1;
    }

}
